import React from 'react';
import { Form, Formik } from 'formik';
import { Button, Grid, SideSheet } from 'ui-toolkit';
import { FormStatusWrapper } from '../shared/FormStatusWrapper/FormStatusWrapper';
import { clientContactFormValidation } from '../../validation/clients/ClientContactFormValidation';
import { ClientContactForm } from './ClientContactForm';
import {
  eContactEnvironment,
  eContactType,
  getContactDuplicationMessage,
} from '../../utilities/contact/duplicationErrorMessage';
import { IFetchStatus } from 'types/rest/IFetchStatus';

interface IAddClientContactProps {
  onSubmit: (value: any) => void;
  onCancel: () => void;
  addFetchError?: Error;
  addFetchStatus: IFetchStatus;
  onAddContact: (email: string) => void;
}

export const AddClientContact: React.FC<IAddClientContactProps> = ({
  onSubmit,
  onCancel,
  addFetchError,
  addFetchStatus,
  onAddContact,
}) => {
  const initialValues = {};

  return (
    <Formik
      initialValues={initialValues}
      validateOnMount={true}
      validationSchema={clientContactFormValidation}
      onSubmit={(values) => {
        onSubmit(values);
      }}
      onReset={onCancel}
    >
      {({ isValid, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <SideSheet
            title={'New Contact'}
            onClose={onCancel}
            footer={
              <Grid columnCount={2}>
                <Button intent={'secondary'} type={'reset'}>
                  Cancel
                </Button>
                <Button intent={'primary'} type={'submit'} disabled={!isValid || !dirty || addFetchStatus.fetching}>
                  Save and Add
                </Button>
              </Grid>
            }
          >
            <Grid>
              <>
                <FormStatusWrapper
                  fetching={addFetchStatus.fetching}
                  fetchedSuccess={addFetchStatus.success}
                  fetchError={addFetchError}
                  successMessage={`Contact Added!`}
                  duplicateMessage={getContactDuplicationMessage(eContactType.Client, eContactEnvironment.Client)}
                />
                <ClientContactForm disableNotEditableFields={false} onAddContact={onAddContact} />
              </>
            </Grid>
          </SideSheet>
        </Form>
      )}
    </Formik>
  );
};
